import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import Sidebar from "../../Sidebar";
import LoadingOverlay from "../../components/LoadingOverlay";
import { printJobCompletion } from "../../services/WorkScheduleServices";
import { displayError } from "../../helpers";
import "../../App.css";

function JobCompletionReport() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cookies] = useCookies(["myToken"]);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [inProgress, setInProgress] = useState(true);
    const pdfUrlRef = useRef(null);

    useEffect(() => {
        setInProgress(true);
        printJobCompletion(cookies, id)
            .then((response) => {
                const file = new Blob([response], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                pdfUrlRef.current = fileURL;
                setPdfUrl(fileURL);
                setInProgress(false);
            })
            .catch((error) => {
                setInProgress(false);
                const errorData = error.response?.data ?? error.message;
                displayError(errorData, "Failed to load job completion report");
            });

        return () => {
            if (pdfUrlRef.current) {
                URL.revokeObjectURL(pdfUrlRef.current);
            }
        };
    }, [cookies, id]);

    const handlePrint = () => {
        const frame = document.getElementById("job-completion-pdf-frame");
        frame?.contentWindow?.focus();
        frame?.contentWindow?.print();
    };

    const handleDownload = () => {
        if (!pdfUrl) {
            return;
        }
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = `job_completion_${id}.pdf`;
        link.click();
    };

    const handleBack = () => {
        navigate("/WorkScheduleTable");
    };

    return (
        <div id="outer-container" className="App">
            <Sidebar pageWrapId="page-wrap" outerContainerId="outer-container" />
            <LoadingOverlay inProgress={inProgress} />
            <div id="page-wrap">
                <div className="container-fluid" style={{ padding: "12px 16px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "12px",
                            gap: "12px",
                            flexWrap: "wrap",
                        }}
                    >
                        <h3
                            style={{
                                color: "rgb(2, 2, 49)",
                                margin: 0,
                                fontWeight: "bold",
                            }}
                        >
                            JOB COMPLETION REPORT
                        </h3>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handlePrint}
                                disabled={!pdfUrl}
                            >
                                Print
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleDownload}
                                disabled={!pdfUrl}
                            >
                                Download
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleBack}
                            >
                                Back
                            </button>
                        </div>
                    </div>

                    <div
                        style={{
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #d0d0d0",
                            borderRadius: "6px",
                            minHeight: "78vh",
                            overflow: "hidden",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        }}
                    >
                        {pdfUrl ? (
                            <iframe
                                id="job-completion-pdf-frame"
                                title="Job Completion Report"
                                src={pdfUrl}
                                style={{
                                    width: "100%",
                                    height: "78vh",
                                    border: "none",
                                    backgroundColor: "#fff",
                                }}
                            />
                        ) : (
                            !inProgress && (
                                <div
                                    style={{
                                        padding: "40px",
                                        textAlign: "center",
                                        color: "#666",
                                    }}
                                >
                                    Unable to display the job completion report.
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobCompletionReport;
